// Shared delivery-date rule used by the PDP estimator and product cards.
// Asia/Dubai is the source of truth, never the browser timezone.
if (!window.AEDeliveryDate) {
  (function () {
    const DAY_MS = 86400000;
    const DUBAI_OFFSET_MS = 4 * 3600000;
    const WEEKDAY_CUTOFF_HOUR = 19;
    const SATURDAY_CUTOFF_HOUR = 15;
    const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const DAYS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const DUBAI_PARTS = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Dubai',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      hourCycle: 'h23',
    });

    function dubaiParts(nowMs) {
      const parts = {};
      DUBAI_PARTS.formatToParts(new Date(nowMs)).forEach((part) => {
        if (part.type !== 'literal') parts[part.type] = Number(part.value);
      });
      return parts;
    }

    function nextUpdate(parts, dayOfWeek, nowMs) {
      const cutoffHour = dayOfWeek === 6
        ? SATURDAY_CUTOFF_HOUR
        : (dayOfWeek === 0 ? null : WEEKDAY_CUTOFF_HOUR);

      if (cutoffHour !== null && parts.hour < cutoffHour) {
        return Date.UTC(parts.year, parts.month - 1, parts.day, cutoffHour) - DUBAI_OFFSET_MS;
      }

      const nextMidnight = Date.UTC(parts.year, parts.month - 1, parts.day + 1) - DUBAI_OFFSET_MS;
      return Math.max(nextMidnight, nowMs + 1);
    }

    // nowMs: epoch ms (defaults to now). Returns UTC-midnight ms of the Dubai calendar
    // day for today and for the delivery day; native Date arithmetic handles rollover.
    function compute(nowMs) {
      const timestamp = nowMs === undefined ? Date.now() : nowMs;
      const parts = dubaiParts(timestamp);
      const todayMs = Date.UTC(parts.year, parts.month - 1, parts.day);
      const dayOfWeek = new Date(todayMs).getUTCDay();
      let daysAhead;

      if (dayOfWeek === 6) {
        daysAhead = parts.hour < SATURDAY_CUTOFF_HOUR ? 2 : 3;
      } else if (dayOfWeek === 0) {
        daysAhead = 2;
      } else {
        daysAhead = parts.hour < WEEKDAY_CUTOFF_HOUR ? 1 : 2;
      }

      return {
        todayMs,
        deliveryMs: todayMs + daysAhead * DAY_MS,
        daysAhead,
        nextUpdateMs: nextUpdate(parts, dayOfWeek, timestamp),
      };
    }

    // Same wording as before: "Tomorrow, Sep 27" / "<weekday>, Sep 28".
    function format(result, longDay) {
      const date = new Date(result.deliveryMs);
      const label = result.daysAhead === 1 ? 'Tomorrow' : (longDay ? DAYS_LONG : DAYS)[date.getUTCDay()];
      return `${label}, ${MONTHS[date.getUTCMonth()]} ${date.getUTCDate()}`;
    }

    window.AEDeliveryDate = { compute, format };
  })();
}
